"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var ConfirmAndEditFile_1 = __importDefault(require("./ConfirmAndEditFile"));
var styles_1 = require("./styles");
var Popover = core_1.Popover;
var FileUpload = function (props) {
    var fileInputRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)({
        file: null,
        fileName: '',
        isOpenEditFileDialog: false,
        isOpenMenu: false
    }), state = _a[0], setState = _a[1];
    var isOpenMenu = state.isOpenMenu, isOpenEditFileDialog = state.isOpenEditFileDialog, fileName = state.fileName, file = state.file;
    (0, react_1.useEffect)(function () {
        if (file) {
            setState(__assign(__assign({}, state), { fileName: file.name }));
        }
    }, [file]);
    (0, react_1.useEffect)(function () {
        if (file && fileName) {
            setState(__assign(__assign({}, state), { isOpenEditFileDialog: true }));
        }
    }, [fileName]);
    var handleFileChange = function () {
        var newFile = fileInputRef.current.files[0];
        setState(__assign(__assign({}, state), { file: newFile }));
    };
    var triggerFileBrowser = function () {
        fileInputRef.current.click();
    };
    var toggleIsOpenMenu = function () {
        setState(__assign(__assign({}, state), { isOpenMenu: !isOpenMenu }));
    };
    var toggleIsOpenDialog = function () {
        setState(__assign(__assign({}, state), { isOpenEditFileDialog: !isOpenEditFileDialog }));
    };
    var changeFileName = function (value) {
        setState(__assign(__assign({}, state), { fileName: value }));
    };
    var eraseFile = function () {
        setState(__assign(__assign({}, state), { fileName: '', file: '' }));
        fileInputRef.current.value = '';
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { style: { display: 'none' }, type: 'file', ref: fileInputRef, onChange: handleFileChange }),
        react_1.default.createElement(core_1.AnchorButton, { minimal: true, onClick: triggerFileBrowser, icon: 'cloud-upload' }),
        react_1.default.createElement(Popover, { content: react_1.default.createElement(styles_1.OptionsMenu, null,
                react_1.default.createElement(core_1.MenuItem, { icon: 'cloud-download' }),
                react_1.default.createElement(core_1.MenuItem, { icon: 'trash' }),
                react_1.default.createElement(core_1.MenuItem, { icon: 'eye-open' })), position: core_1.Position.BOTTOM_LEFT, shouldReturnFocusOnClose: false },
            react_1.default.createElement(core_1.AnchorButton, { minimal: true, onClick: toggleIsOpenMenu, icon: 'menu' })),
        isOpenEditFileDialog && (react_1.default.createElement(ConfirmAndEditFile_1.default, { isOpen: isOpenEditFileDialog, toggleIsOpen: toggleIsOpenDialog, fileName: fileName, triggerFileBrowser: triggerFileBrowser, changeFileName: changeFileName, eraseFile: eraseFile, handleFinish: toggleIsOpenDialog, file: file }))));
};
exports.FileUpload = FileUpload;
